import { Carousel } from "@mantine/carousel";
import { Box, Center, Group, Image, Stack, Text, Tooltip } from "@mantine/core";
import Carousel8Style from "../carousel8/carousel8.module.scss";
import carouselClasses from "./carousel.module.scss";

import { LocalStorageKey } from "@/services/constants";
import parse from "html-react-parser";
import { useEffect, useState } from "react";
import { loadData } from "../carouel";
import { purfifyHTML } from "@/services/services";
import { useWindowSize } from "usehooks-ts";

export default function Carousel11({
  options,
  url,
  variables,
  defaultImage,
  display,
}) {
  const [data, setData] = useState([]);
  const isMobile = useWindowSize().width < 768;
  const isTablet = useWindowSize().width < 1000;

  const componentStyle = options?.styles;

  const wrapperStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 32,
    padding: 48,
    paddingLeft: isMobile ? 24 : 48,
    paddingRight: isMobile ? 24 : 48,
    width: "100%",
  };

  const titleStyle = {
    fontSize: 48,
    fontWeight: "bold",
    textAlign: "center",
    color: variables.primaryColor,
  };

  const newsCardStyle = {
    cursor: "pointer",
    display: "flex",
    flexDirection: "column",
    borderRadius: 4,
    position: "relative",
    cursor: "pointer",
    height: 250,
    borderRadius: 4,
    newsCardTitle: {
      background: "#000000BB",
      position: "absolute",
      bottom: 0,
      padding: 12,
      fontSize: 16,
      color: "#fff",
      lineHeight: "28px",
      textAlign: "left",
      letterSpacing: -0.5,
      fontWeight: 250,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
    },
  };

  const carouselStyle = {
    controls: {
      left: "auto",
      gap: 24,
      bottom: 48,
      top: "auto",
      control: {
        width: 56,
        height: 40,
        border: `1px solid ${variables.primaryColor}`,
        borderRadius: 4,
        boxShadow: "none",
      },
    },
    indicators: {
      bottom: 60,
      right: "auto",
      indicator: {},
    },
  };

  useEffect(() => {
    if (options.useApi) {
      loadData(
        {
          url: url,
          data: options.data,
          query: options.query,
          jsonata: options.jsonata,
          display: display,
        },
        setData,
      );
    } else {
      setData(options.dataSource || []);
    }

    return () => {
      setData([]);
    };
  }, []);

  const contentJSX = data.map((dataSingle, index) => {
    let cardJSX = <></>;

    let image = null;

    if (dataSingle.image && !dataSingle.image.includes("null")) {
      image = dataSingle.image;
    }
    switch (options.cardType) {
      case "news":
        {
          cardJSX = (
            <div
              style={{
                ...newsCardStyle,
                ...(componentStyle?.newCardStyle || {}),
              }}
              // className={carouselClasses.newsCard}
              onClick={() => {
                if (dataSingle.data && dataSingle.data.id) {
                  sessionStorage.removeItem(
                    LocalStorageKey.NEWS_DATA + dataSingle.data.id,
                  );
                  sessionStorage.setItem(
                    LocalStorageKey.NEWS_DATA + dataSingle.data.id,
                    JSON.stringify({
                      image,
                      title: dataSingle.title,
                      ...dataSingle.data,
                    }),
                  );
                  const a = document.createElement("a");
                  a.target = options.target;
                  a.href =
                    options.data +
                    `/${dataSingle.data.id || "1"}` +
                    `?type_child=${options.child}` +
                    "&useApi=false";

                  a.click();
                }
              }}
            >
              <Image
                src={image || defaultImage}
                alt="news image"
                radius={
                  componentStyle?.newCardStyle?.borderRadius ||
                  newsCardStyle.borderRadius
                }
              />
              <Tooltip withArrow label={dataSingle.title} multiline>
                <Text
                  lineClamp={3}
                  style={{
                    ...newsCardStyle.newsCardTitle,
                    ...(componentStyle?.newCardStyle?.newsCardTitle || {}),
                  }}
                >
                  {dataSingle.title}
                </Text>
              </Tooltip>
            </div>
          );
        }
        break;
      default: {
        cardJSX = (
          <div className={carouselClasses.defaultCard}>
            <Center
              bg={dataSingle.background || variables.secondColor}
              h={"100%"}
              style={{ borderRadius: 8 }}
              px={8}
            >
              <Text
                className={Carousel8Style.title9}
                c={dataSingle.color || variables.primaryColor}
              >
                {(index + 1).toString().padStart(2, "0")}
              </Text>
            </Center>
            <Stack
              spacing={16}
              style={{ minHeight: 150, justifyContent: "start" }}
            >
              <Text
                className={Carousel8Style.title9}
                c={dataSingle.color || variables.primaryColor}
              >
                {dataSingle.title}
              </Text>
              <Text
                c={"var(--primary-4)"}
                lineClamp={4}
                className={Carousel8Style.content9}
              >
                {parse(purfifyHTML(dataSingle.description))}
              </Text>
            </Stack>
          </div>
        );
      }
    }

    return (
      <Carousel.Slide
        key={index}
        style={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
        }}
      >
        {cardJSX}
      </Carousel.Slide>
    );
  });

  return (
    <div
      style={{
        ...wrapperStyle,
        ...(componentStyle || {}),
      }}
    >
      <Group position="center">
        <Text
          style={{
            ...titleStyle,
            ...(componentStyle?.header || {}),
          }}
        >
          {parse(purfifyHTML(options.title || ""))}
        </Text>
      </Group>

      <Box>
        <Carousel
          slideSize={"33.3333333%"}
          slidesToScroll={options.slidesToScroll || 1}
          pb={140}
          styles={{
            controls: {
              ...carouselStyle.controls,
              ...(componentStyle?.carouselStyle?.controls || {}),
            },
            control: {
              ...carouselStyle.controls.control,
              ...(componentStyle?.carouselStyle?.controls?.control || {}),
            },
            indicators: {
              ...carouselStyle.indicators,
              ...componentStyle?.carouselStyle?.indicators,
            },
            indicator: {
              ...carouselStyle.indicators.indicator,
              ...(componentStyle?.carouselStyle?.indicators?.indicator || {}),
            },
          }}
          classNames={{
            indicator: carouselClasses.indicator,
          }}
          align="start"
          slideGap={options.slideGap || 32}
          loop={options.hasLoop && true}
          breakpoints={[
            { maxWidth: "md", slideSize: "50%" },
            { maxWidth: "xs", slideSize: "100%", slideGap: 0 },
          ]}
          draggable={false}
        >
          {contentJSX}
        </Carousel>
      </Box>
    </div>
  );
}
